import React, { Component } from 'react';
import PropTypes from 'prop-types';
import closest from 'dom-closest';

// Constants
const FULL_IMAGE_SIZE = 1600;

class ProductImageGallery extends Component {

  constructor(props) {
    super(props);

    this.updateIndex = this.updateIndex.bind(this);
    this.setupHoverZoom = this.setupHoverZoom.bind(this);
    this.destroyHoverZoom = this.destroyHoverZoom.bind(this);
    this.calculateMeasurements = this.calculateMeasurements.bind(this);
    this.mousemovePdp = this.mousemovePdp.bind(this);
    this.calculateMeasurements = this.calculateMeasurements.bind(this);
    this.calculatePixelOffset = this.calculatePixelOffset.bind(this);
    this.capZoomImageWidth = this.capZoomImageWidth.bind(this);

    this.state = {
      index: 0,
      measurements: {
        productImage: {},
        zoomHoverCard: {},
        zoomOffsetScalar: {}
      },
      showTimeout: null,
      zoomActive: false,
      zoomHoverCardStyle: {},
      zoomImageStyle: {},
      zoomImageCap: {}
    };
  }

  setupHoverZoom() {
    const productImage = this.productImageRef;

    // we need to make sure the zoom image doesn't spill out of it's container.
    // this problem presents itself on XL screens
    this.capZoomImageWidth();

    // calculate our measurements
    this.calculateMeasurements();

    // add listeners for scrolling and mousemovements and perform appropriate actions
    // $scrollContainer.on('scroll.pdp', calculateMeasurements);
    productImage.addEventListener('mousemove', this.mousemovePdp);

    // show our zoom elements after a timeout
    const showTimeout = setTimeout(() => {
      const { measurements, zoomHoverCardStyle } = this.state;

      this.setState({
        zoomActive: true,
        zoomHoverCardStyle: {
          ...zoomHoverCardStyle,
          width: measurements.zoomHoverCard.dimensions.x,
          height: measurements.zoomHoverCard.dimensions.y
        }
      });
    }, 500);
    this.setState({ showTimeout });
  }

  getZoomImageMaxWidth() {
    const elem = this.productImageRef;
    const dpWrapper = closest(elem, '.pdp, .kdp');

    return (dpWrapper) ? Math.max(0, dpWrapper.offsetWidth - elem.offsetWidth - 40) : null;
  }

  mousemovePdp(event) {
    const { measurements, zoomHoverCardStyle, zoomImageStyle } = this.state;

    const xPixelOffset = this.calculatePixelOffset(event.pageX, 'x');
    const yPixelOffset = this.calculatePixelOffset(event.pageY, 'y');

    this.setState({
      zoomHoverCardStyle: {
        ...zoomHoverCardStyle,
        left: xPixelOffset + 10,
        top: yPixelOffset
      },
      zoomImageStyle: {
        ...zoomImageStyle,
        backgroundPosition: `${-1 * xPixelOffset * measurements.zoomOffsetScalar}px ${-1 * yPixelOffset * measurements.zoomOffsetScalar}px`
      }
    });
  }

  updateIndex(hoverIndex) {
    this.setState({
      index: hoverIndex
    });
  }

  destroyHoverZoom() {
    const { showTimeout } = this.state;
    const productImage = this.productImageRef;

    // clear timeout
    clearTimeout(showTimeout);
    this.setState({
      showTimeout: null
    });

    // hide zoom elements
    this.setState({
      zoomActive: false
    });

    // remove listeners
    // $scrollContainer.off('scroll.pdp');
    productImage.removeEventListener('mousemove', this.mousemovePdp);
  }

  calculatePixelOffset(pageOffset, axis) {
    const { measurements } = this.state;

    return Math.min(
      measurements.zoomHoverCard.limits[axis],
      Math.max(
        0,
        pageOffset - measurements.productImage.offset[axis] - (measurements.zoomHoverCard.dimensions[axis] / 2)
      )
    );
  }

  capZoomImageWidth() {
    const zoomImageMaxWidth = this.getZoomImageMaxWidth();
    if (zoomImageMaxWidth) {
      this.setState({
        zoomImageCap: {
          maxWidth: `${zoomImageMaxWidth}px`
        }
      });
    }
  }

  calculateMeasurements() {
    const productImage = this.productImageRef;

    const rect = productImage.getBoundingClientRect();
    const productImageOffset = {
      x: rect.left + window.pageXOffset,
      y: rect.top + window.pageYOffset
    };
    const productImageDimensions = {
      x: productImage.offsetWidth,
      y: productImage.offsetHeight
    };
    const zoomHoverCardScalar = this.getZoomImageMaxWidth() / FULL_IMAGE_SIZE;
    const zoomOffsetScalar = FULL_IMAGE_SIZE / productImageDimensions.x;
    const zoomHoverCardDimensions = {
      x: productImageDimensions.x * zoomHoverCardScalar,
      y: productImageDimensions.y * zoomHoverCardScalar
    };
    const zoomHoverCardLimits = {
      x: productImageDimensions.x - zoomHoverCardDimensions.x,
      y: productImageDimensions.y - zoomHoverCardDimensions.y
    };

    // set our measurements "global"
    this.setState({
      measurements: {
        productImage: {
          dimensions: productImageDimensions,
          offset: productImageOffset
        },
        zoomHoverCard: {
          dimensions: zoomHoverCardDimensions,
          limits: zoomHoverCardLimits
        },
        zoomOffsetScalar
      }
    });
  }

  render() {
    const { images, hideZoom, badgeImageUrl } = this.props;
    const { index, zoomActive, zoomHoverCardStyle, zoomImageStyle, zoomImageCap } = this.state;

    if (!images || images.length === 0) return null;

    return (
      <div className="product-gallery" onMouseLeave={this.destroyHoverZoom}>
        <div className={`product-image ${!zoomActive ? 'product-badge-container' : ''}`} ref={c => (this.productImageRef = c)} onMouseEnter={this.setupHoverZoom}>
          {/* promo badge */}
          {(index === 0 && window.zola.feature.productBadging && badgeImageUrl) && (
          <div className={`product-badge ${zoomActive ? 'zoom-active' : ''}`} >
            <img className="product-badge" src={badgeImageUrl} role="presentation" />
          </div>
          )}
          {/* main image */}
          <img src={images[index].large} className="img-force-fill" alt="" />
          {!hideZoom && (
            <div className={`zoom-hover-card ${zoomActive ? 'active' : ''}`} style={zoomHoverCardStyle} />
          )}
        </div>

        {/* thumbnails */}
        {images.length > 1 && (
          <div className="product-image-thumbnails hidden-xs">
            {images.map((image, hoverIndex) => (
              (hoverIndex === 0 && window.zola.feature.productBadging && badgeImageUrl)
              ? <div className="product-image-thumbnails product-badge-container">
                <div className="product-badge">
                  <img className="product-badge" src={badgeImageUrl} role="presentation" />
                </div>
                <img key={hoverIndex} className="product-thumb" src={images[hoverIndex].thumb} alt="" onMouseOver={() => this.updateIndex(hoverIndex)} />
              </div>
              : <img key={hoverIndex} className="product-thumb" src={images[hoverIndex].thumb} alt="" onMouseOver={() => this.updateIndex(hoverIndex)} />
            )
            )}
          </div>
        )}

        {!hideZoom && (
          /* zoom image */
          <div
            className={`zoom-image ${zoomActive ? 'active' : ''}`}
            ref={c => (this.zoomImageRef = c)}
            style={zoomImageCap}
          >
            <div style={{ backgroundImage: `url(${images[index].full})`, ...zoomImageStyle }} />
          </div>
        )}

      </div>
    );
  }
}

ProductImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      thumb: PropTypes.string,
      small: PropTypes.string,
      medium: PropTypes.string,
      large: PropTypes.string,
      full: PropTypes.string
    })
  ),
  hideZoom: PropTypes.bool,
  badgeImageUrl: PropTypes.string
};

export default ProductImageGallery;



/** WEBPACK FOOTER **
 ** ./src/components/product/ProductImageGallery.jsx
 **/